import React from 'react';
import { Mail, MapPin, Phone, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Departamento de Lenguas
            </h3>
            <div className="space-y-3 text-gray-600">
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">Calle 72 No. 11-86, Bogotá D.C.</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span className="text-sm">+57 (1) 594 1894</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span className="text-sm">lenguas@upn.edu.co</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Recursos Académicos
            </h3>
            <div className="space-y-2 text-gray-600">
              <a href="#" className="flex items-center space-x-2 text-sm hover:text-emerald-600 transition-colors">
                <ExternalLink className="w-3 h-3" />
                <span>Repositorio Institucional</span>
              </a>
              <a href="#" className="flex items-center space-x-2 text-sm hover:text-emerald-600 transition-colors">
                <ExternalLink className="w-3 h-3" />
                <span>Trabajos de Grado</span>
              </a>
              <a href="#" className="flex items-center space-x-2 text-sm hover:text-emerald-600 transition-colors">
                <ExternalLink className="w-3 h-3" />
                <span>Investigaciones</span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Universidad Pedagógica Nacional
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Formando educadores para la transformación de la sociedad colombiana desde 1955.
            </p>
            <a 
              href="https://www.upn.edu.co" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-sm text-emerald-600 hover:text-emerald-700 transition-colors"
            >
              <span>Visitar sitio oficial</span>
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-500">
            © 2024 Universidad Pedagógica Nacional - Departamento de Lenguas. 
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;